const RequestMethods = {
  POST: 'post',
  GET: 'get',
  PUT: 'put',
  DELETE: 'delete'
}
export default RequestMethods
